"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const sharedStyles_1 = require("components/TransactionRegister/sharedStyles");
const styles = (theme) => (Object.assign(Object.assign({}, (0, sharedStyles_1.sharedStyles)(theme)), { helpIcon: {
        display: 'flex',
        cursor: 'pointer',
        color: theme.palette.slateGrey,
    }, dialogRoot: {
        zIndex: '1501 !important',
    }, headerContainer: {
        height: 67,
        background: theme.palette.grey.level2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '8px 8px 0px 0px',
        padding: theme.spacing(1),
        borderBottom: 'none',
    }, headerCheckbox: {
        paddingTop: 2,
    }, headerCheckboxBorder: {
        border: 'solid',
        borderWidth: 1,
        borderColor: theme.palette.grey.level3,
    }, headerLabel: {
        display: 'flex',
        marginLeft: 7,
        fontSize: '14px',
        fontWeight: 500,
        color: theme.palette.text.primary,
    }, payeePopper: {
        zIndex: theme.zIndex.mobileStepper,
    }, inputRoot: {
        fontSize: theme.components.register.fontSize.default,
    }, payeeRoot: {
        height: 20,
        margin: '4px 0',
    }, autoCompleteRoot: {
        width: '100%',
        overflow: 'hidden',
    } }));
exports.styles = styles;
